import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=3d84e1b4&scoped=true"
import script from "./GroupEdit.vue?vue&type=script&lang=ts"
export * from "./GroupEdit.vue?vue&type=script&lang=ts"
import style0 from "./GroupEdit.vue?vue&type=style&index=0&id=3d84e1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d84e1b4",
  null
  
)

export default component.exports